import React from 'react';
import { motion } from 'framer-motion';

const PolitiqueConfidentialitePage = () => {
    return (
        <div className="min-h-screen bg-gray-900 text-white">
            <div className="container mx-auto px-4 py-4 md:py-8 lg:py-12">
                <motion.div
                    initial={{ opacity: 0, y: 20 }}
                    animate={{ opacity: 1, y: 0 }}
                    transition={{ duration: 0.5 }}
                    className="container mx-auto px-4 py-8 md:py-12 lg:py-16 bg-gray-900 text-white"
                >
                    <h1 className="text-3xl font-bold text-center mb-8 text-white">Politique de Confidentialité</h1>
                    <p className="text-gray-300">
                        Dernière mise à jour : 02 / 04 / 2025
                    </p>
                    <br />
                    <p className="text-gray-300">
                        Sev Remorque s'engage à protéger la confidentialité de vos informations personnelles. Cette politique de confidentialité
                        explique comment nous recueillons, utilisons et divulguons vos informations lorsque vous utilisez notre site web et nos services.<br />
                        <a 
                            href="https://www.dépannage-occitanie.com"
                            className="text-1xl font-semibold text-yellow-200"
                        >
                            https://www.dépannage-occitanie.com
                        </a> 
                    </p>

                    <br />
                    <section className="mb-8 space-y-4">
                        <h2 className="text-2xl font-semibold text-yellow-400">1. Informations que nous recueillons</h2>
                        <p className="text-gray-300">
                            Nous pouvons recueillir différents types d'informations, notamment :
                        </p>
                        <ul className="list-disc list-inside space-y-2">
                            <li className="text-gray-300">
                                <span className="font-semibold text-white">Informations d'identification personnelle :</span> Nom, adresse, numéro de téléphone,
                                adresse e-mail, etc., que vous nous fournissez volontairement lorsque vous demandez un devis.
                            </li>
                            <li className="text-gray-300">
                                <span className="font-semibold text-white">Informations de localisation :</span> Si vous utilisez les services de localisation
                                de votre appareil, nous pouvons recueillir des informations sur votre position géographique pour vous fournir
                                des services de dépannage à proximité.
                            </li>
                            <li className="text-gray-300">
                                <span className="font-semibold text-white">Informations sur le véhicule :</span> Type de véhicule, plaque
                                d'immatriculation, etc., nécessaires pour fournir nos services de dépannage.
                            </li>
                            <li className="text-gray-300">
                                <span className="font-semibold text-white">Informations techniques :</span> Adresse IP, type de navigateur,
                                système d'exploitation, données de journal, etc., recueillies automatiquement lorsque vous utilisez notre Site.
                            </li>
                            <li className="text-gray-300">
                                <span className="font-semibold text-white">Cookies et technologies similaires :</span> Nous utilisons des cookies
                                pour améliorer votre expérience sur notre site, personnaliser le contenu et les publicités, et analyser notre trafic.
                            </li>
                        </ul>
                    </section>

                    <section className="mb-8 space-y-4">
                        <h2 className="text-2xl font-semibold text-yellow-400">2. Comment nous utilisons vos informations</h2>
                        <p className="text-gray-300">
                            Nous pouvons utiliser vos informations aux fins suivantes :
                        </p>
                        <ul className="list-disc list-inside space-y-2">
                            <li className="text-gray-300">Fournir et améliorer nos services de dépannage.</li>
                            <li className="text-gray-300">Répondre à vos demandes de devis, questions et demandes de service client.</li>
                            <li className="text-gray-300">Personnaliser votre expérience sur notre Site.</li>
                            <li className="text-gray-300">Vous envoyer des informations promotionnelles et marketing, si vous avez consenti à les recevoir.</li>
                            <li className="text-gray-300">Analyser l'utilisation de notre Site et améliorer nos services.</li>
                            <li className="text-gray-300">Se conformer aux obligations légales et réglementaires.</li>
                        </ul>
                    </section>

                    <section className="mb-8 space-y-4">
                        <h2 className="text-2xl font-semibold text-yellow-400">3. Divulgation de vos informations</h2>
                        <p className="text-gray-300">
                            Nous pouvons divulguer vos informations aux catégories de destinataires suivantes :
                        </p>
                        <ul className="list-disc list-inside space-y-2">
                            <li className="text-gray-300">
                                <span className="font-semibold text-white">Prestataires de services :</span> Nous pouvons partager vos informations avec
                                des prestataires de services tiers qui nous aident à fournir nos services.
                            </li>
                            <li className="text-gray-300">
                                <span className="font-semibold text-white">Partenaires de dépannage :</span> Pour vous fournir des services de dépannage,
                                nous pouvons partager vos informations avec des dépanneurs indépendants situés à proximité de votre emplacement.
                            </li>
                            <li className="text-gray-300">
                                <span className="font-semibold text-white">Autorités légales :</span> Nous pouvons divulguer vos informations si la loi
                                l'exige ou en réponse à une demande valide d'une autorité gouvernementale.
                            </li>
                            <li className="text-gray-300">
                                 <span className="font-semibold text-white">Transferts d'entreprise :</span> Dans le cas d'une fusion, d'une acquisition
                                ou d'une vente d'actifs, vos informations peuvent être transférées à l'entité acquérante.
                            </li>
                             <li className="text-gray-300">
                                <span className="font-semibold text-white">Avec votre consentement :</span> Nous pouvons partager vos informations avec
                                des tiers avec votre consentement.
                            </li>
                        </ul>
                    </section>

                    <section className="mb-8 space-y-4">
                        <h2 className="text-2xl font-semibold text-yellow-400">4. Vos droits</h2>
                        <p className="text-gray-300">
                            Vous disposez des droits suivants concernant vos informations personnelles :
                        </p>
                        <ul className="list-disc list-inside space-y-2">
                            <li className="text-gray-300">
                                <span className="font-semibold text-white">Droit d'accès :</span> Vous pouvez demander à accéder aux informations
                                personnelles que nous détenons à votre sujet.
                            </li>
                            <li className="text-gray-300">
                                <span className="font-semibold text-white">Droit de rectification :</span> Vous pouvez nous demander de corriger toute
                                information inexacte ou incomplète.
                            </li>
                            <li className="text-gray-300">
                                <span className="font-semibold text-white">Droit à l'effacement :</span> Vous pouvez nous demander de supprimer vos
                                informations personnelles, sous réserve des exceptions légales.
                            </li>
                            <li className="text-gray-300">
                                <span className="font-semibold text-white">Droit à la limitation du traitement :</span> Vous pouvez nous demander
                                de limiter le traitement de vos informations personnelles dans certaines circonstances.
                            </li>
                            <li className="text-gray-300">
                                 <span className="font-semibold text-white">Droit à la portabilité des données :</span> Vous pouvez demander à recevoir
                                 une copie de vos informations personnelles dans un format structuré, couramment utilisé et lisible par machine.
                            </li>
                            <li className="text-gray-300">
                                <span className="font-semibold text-white">Droit d'opposition :</span> Vous pouvez vous opposer au traitement de vos
                                informations personnelles à des fins de marketing direct ou pour d'autres motifs légitimes.
                            </li>
                            <li className="text-gray-300">
                                <span className="font-semibold text-white">Droit d'introduire une réclamation auprès d'une autorité de contrôle :</span>
                                 Vous avez le droit de déposer une réclamation auprès de la Commission Nationale de l'Informatique et des Libertés (CNIL)
                                 si vous estimez que le traitement de vos données enfreint la réglementation applicable.
                            </li>
                        </ul>
                        <p className="text-gray-300">
                            Pour exercer vos droits, veuillez nous contacter à l'adresse indiquée ci-dessous.
                        </p>
                    </section>

                    <section className="mb-8 space-y-4">
                        <h2 className="text-2xl font-semibold text-yellow-400">5. Sécurité des données</h2>
                        <p className="text-gray-300">
                            Nous mettons en œuvre des mesures de sécurité techniques et organisationnelles appropriées pour protéger vos informations
                            personnelles contre la perte, l'utilisation abusive et l'accès non autorisé, la divulgation, l'altération ou la destruction.
                            Cependant, veuillez noter qu'aucune transmission de données sur Internet ou aucun système de stockage n'est totalement sécurisé.
                        </p>
                    </section>

                    <section className="mb-8 space-y-4">
                        <h2 className="text-2xl font-semibold text-yellow-400">6. Conservation des données</h2>
                        <p className="text-gray-300">
                            Nous conservons vos informations personnelles aussi longtemps que nécessaire pour atteindre les finalités pour lesquelles
                            elles ont été recueillies, y compris pour nous conformer à nos obligations légales, résoudre les litiges et faire appliquer nos accords.
                        </p>
                    </section>

                    <section className="mb-8 space-y-4">
                        <h2 className="text-2xl font-semibold text-yellow-400">7. Liens vers d'autres sites web</h2>
                        <p className="text-gray-300">
                            Notre Site peut contenir des liens vers des sites web de tiers. Nous ne sommes pas responsables des pratiques de confidentialité
                            de ces sites web. Nous vous recommandons de consulter les politiques de confidentialité de ces sites avant de leur fournir vos
                            informations personnelles.
                        </p>
                    </section>

                    <section className="mb-8 space-y-4">
                        <h2 className="text-2xl font-semibold text-yellow-400">8. Modifications de cette politique de confidentialité</h2>
                        <p className="text-gray-300">
                            Nous pouvons mettre à jour cette politique de confidentialité de temps à autre. Nous vous informerons de toute modification
                            importante en publiant la nouvelle politique de confidentialité sur notre Site. Nous vous encourageons à consulter régulièrement
                            cette politique pour prendre connaissance des éventuelles modifications.
                        </p>
                    </section>
                    <section className="mb-8 space-y-4">
                        <h2 className="text-2xl font-semibold text-yellow-400">9. Nous contacter</h2>
                        <p className="text-gray-300">
                            Si vous avez des questions concernant cette politique de confidentialité ou nos pratiques en matière de données,
                            veuillez nous contacter à l'adresse suivante :
                        </p>
                        <p className="text-gray-300">
                            Sev Remorque
                        </p>
                        <p className="text-gray-300">
                            66000 PERPIGNAN, 41 Rue des oiseaux
                        </p>
                        <p className="text-gray-300">
                            severincortes7@gmail.com
                        </p>
                        <p className="text-gray-300">
                            06.99.46.31.59
                        </p>
                    </section>
                </motion.div>
            </div>
        </div>
    );
};

export default PolitiqueConfidentialitePage;
